import React from 'react'
import { i18n, init as i18nInit } from './i18n'
import ReactDOM from 'react-dom/client'
import App from './App'
;(async function () {
  //AuthToken.applyFromLocationUrlIfExists();
  await i18nInit()
  document.title = i18n('app.title')
  const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement)
  // root.render(
  //   <React.StrictMode>
  //     <App />
  //   </React.StrictMode>
  // )
  root.render(<App />)
})()
